import { SurveyDeployerPageResponseJSON } from './../Survey-Deployer-Page-Response-JSON';

export class PageFooterResponseJSON extends SurveyDeployerPageResponseJSON{
    copyrightMessage: String;
    footerLogoPath: String;
} 